import React from "react";
import Box from "@mui/material/Box";
import {useRowEditContext} from "./RowEditContext";
import {ROW_BANNER_TRANSITION_MS} from "./rowEditConstants";

export const RowBanner: React.FC = () =>
{
   const ctx = useRowEditContext();
   if (!ctx)
   {
      return null;
   }
   const state = ctx.rowBannerState;

   let message: string | null = null;
   switch (state.kind)
   {
      case "none":
         break;
      case "hasFieldErrors":
         //////////////////////////////////////////////////////////////////////////
         // Per-cell errors already render beneath each input, and the offending //
         // cell is scrolled into view on save.  No row-level banner —           //
         // matches RecordScreen's behavior and keeps the row compact.           //
         //////////////////////////////////////////////////////////////////////////
         break;
      case "formDisabled":
         message = state.message;
         break;
      case "saveError":
         message = state.message;
         break;
      case "saveSuccess":
         //////////////////////////////////////////////////////////////////////////
         // Handled in EditRowActions as a green "Saved" label where the buttons //
         // sit; no full-width banner is shown for the success case.             //
         //////////////////////////////////////////////////////////////////////////
         break;
   }

   return (
      <Box
         sx={{
            overflow:       "visible",
            display:        "flex",
            alignItems:     "center",
            justifyContent: "center",
            py:             message ? "4px" : 0,
         }}
      >
         {message && (
            <Box
               className="qqq-row-edit-row-error-text"
               sx={{
                  color:      "error.main",
                  fontSize:   "0.95rem",
                  fontWeight: 500,
                  textAlign:  "center",
                  whiteSpace: "normal",
                  wordBreak:  "break-word",
                  px:         2,
                  lineHeight: 1.4,
               }}
            >
               {message}
            </Box>
         )}
      </Box>
   );
};
